// Lib
import React, { useEffect, useState } from "react";

// Hook
import useDebounce from "../../../utils/hooks/useDebounce";
import useRoveFocus from "../../../utils/hooks/useRoveFocus";

// Component
import Item from "./autocomplete/Item";

// Module
import { getAutocomplete } from "../../../module/suppliers/listings/autocomplete";

// Style
import { List } from "./AutocompleteStyle";

const Autocomplete = ({
  keywords,
  wasSubmit,
  searchTerm,
  setSelectedSuggestedWord
}) => {
  // Local State
  const [prevDebouncedSearchTerm, setPrevDebouncedSearchTerm] = useState("");
  const [results, setResults] = useState([]); // API search results

  // Hooks
  const debouncedSearchTerm = useDebounce(searchTerm, 500);
  const [focus, setFocus] = useRoveFocus(results.length);

  // Effect for API call
  useEffect(
    () => {
      if (
        debouncedSearchTerm.length >= 3 &&
        debouncedSearchTerm !== prevDebouncedSearchTerm &&
        debouncedSearchTerm !== keywords
      ) {
        setPrevDebouncedSearchTerm(debouncedSearchTerm);
        // Create an scoped async function
        async function getSuggestions() {
          const suggestions = await getAutocomplete({
            keyword: debouncedSearchTerm
          });
          setResults(suggestions.json);
        }

        setFocus(-1); // It removes focus
        getSuggestions();
      } else {
        setFocus(-1);
        setResults([]);
      }
    },
    [debouncedSearchTerm, prevDebouncedSearchTerm, keywords] // Only call effect if debounced search term changes
  );

  useEffect(
    () => {
      results[focus] && setSelectedSuggestedWord(results[focus]);
    },
    [focus, setSelectedSuggestedWord]
  );

  useEffect(
    () => {
      setResults([]);
    },
    [wasSubmit]
  );

  return (
    <List data-hidden={results.length === 0}>
      {results.map((result, index) => {
        return (
          <Item
            key={result}
            focus={focus === index}
            index={index}
            result={result}
            setFocus={setFocus}
            setResults={setResults}
            setSelectedSuggestedWord={setSelectedSuggestedWord}
            searchTerm={debouncedSearchTerm}
          />
        );
      })}
    </List>
  );
};

export default Autocomplete;



// WEBPACK FOOTER //
// ./src/newDropshipperApp/pages/search/header/Autocomplete.js